import { render, staticRenderFns } from "./agreement2.vue?vue&type=template&id=57a9e7c6"
import script from "./agreement2.vue?vue&type=script&lang=js"
export * from "./agreement2.vue?vue&type=script&lang=js"
import style0 from "./agreement2.vue?vue&type=style&index=0&id=57a9e7c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports